import React, { useEffect, useState, useRef } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Button,
  Grid,
  TextField,
  CircularProgress,
  Dialog,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateField } from "@mui/x-date-pickers/DateField";
import { DatePicker } from "@mui/x-date-pickers";
import { useNavigate } from "react-router-dom";
import { validateEmail } from "../../../utils";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import sendCreditAxios from "../../../utils/sendCreditAxiosService";

const TransactionStatus = () => {
  const baseURL = process.env.REACT_APP_SENDCREDIT_API_URL;

  const [data, setData] = useState<any>([]);
  const [email, setEmail] = useState<string>("");
  const [startDate, setStartDate] = useState<string | null>("");
  const [endDate, setEndDate] = useState<string | null>("");
  const [id, setId] = useState<string>("");
  const [action, setAction] = useState<Boolean>(false);
  const [showButton, setShowButton] = useState(false);
  const agGridRef = useRef<AgGridReact | null>(null);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("user")) {
      var user = JSON.parse(localStorage.getItem("user") || "");
      if (user.Email == "tahir.shahzad@now.net.pk") {
        navigate("/fusionhub/transaction-status");
      } else {
        navigate("/support/portin");
      }
    }
  }, []);

  useEffect(() => {
    // Check if any of the fields has a value
    const hasValue = id || email || startDate || endDate;
    setShowButton(Boolean(hasValue)); // Show button if any field has a value
  }, [id, email, startDate, endDate]);

  const columnDefs: ColDef[] = [
    {
      field: "cartCreationDate",
      headerName: "Creation Date",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "orderCheckoutDate",
      headerName: "Checkout Date",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "categoryName",
      headerName: "Category Name",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "subCategoryName",
      headerName: "Subcategory Name",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "productName",
      headerName: "Product Name",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "operatorName",
      headerName: "Operator Name",
      filter: true,
      sortable: true,
      resizable: true,
    },

    {
      field: "transactionID",
      headerName: "Transaction ID ",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "userEmail",
      headerName: "Email ",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "purchaseInventoryStatus",
      headerName: "Inventory Status",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "failureReason",
      headerName: "Failure Reason",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "vendorFinalStatus",
      headerName: "Final Status",
      filter: true,
      sortable: true,
      resizable: true,
    },

    {
      field: "paymentMethod",
      headerName: "Payment Method",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "refund",
      headerName: "Refund",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "message",
      headerName: "Message",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "orderAmount",
      headerName: "Order Amount",
      filter: true,
      sortable: true,
    },

    {
      field: "paymentResposne",
      headerName: "PaymentResposne",
      filter: true,
      sortable: true,
      resizable: true,
    },
  ];

  const onRowClicked = (event: { data: any }) => {
    const rowData = event.data;
    setSelectedRowData(rowData);
    setOpen(true);
  };
  const handleGetBundles = async () => {
    toast.dismiss();

    if (startDate && dayjs(startDate).isAfter(dayjs())) {
      toast.error("Please enter the valid StartDate");
      return;
    }
    if (startDate == "Invalid Date" || endDate == "Invalid Date") {
      toast.error("Please enter valid Date");
      return;
    }

    // Validate end date is not less than the start date
    if (startDate && endDate && dayjs(endDate).isBefore(dayjs(startDate))) {
      toast.error("EndDate should be greater or Equal to StartDate  ");
      return;
    }
    if (email.trim() !== "") {
      if (!validateEmail(email.trim())) {
        toast.error("Please enter valid email address");
        return;
      }
    }

    setData(null);
    setAction(true);
    requestBundles();
  };

  console.log(startDate);

  const requestBundles = async () => {
    await sendCreditAxios
      .post(`/CRMTransaction/GetTransactionsAsync`, {
        ...(startDate ? { fromDate: startDate } : {}),
        ...(endDate ? { toDate: endDate } : {}),
        transactionfilters: {
          transactionId: id,
          userEmail: email,
        },
      })
      .then((res: any) => {
        setAction(false);
        const apiresponse = res.data?.payload;
        if (apiresponse?.length > 0) {
          setData(apiresponse);
        } else {
          toast.info("Record not found.");
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Transaction Status</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                className="formControl"
                label="Transaction Id"
                variant="outlined"
                defaultValue={id}
                onChange={(e) => setId(e.target.value)}
                inputProps={{ maxLength: 35 }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                className="formControl"
                label="Email"
                variant="outlined"
                defaultValue={email}
                onChange={(e) => setEmail(e.target.value)}
                inputProps={{ maxLength: 35 }}
              />
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="StartDate"
                  value={startDate ? dayjs(startDate) : null}
                  onChange={(date: dayjs.Dayjs | null) =>
                    setStartDate(date ? date.format("YYYY-MM-DD") : null)
                  }
                  slotProps={{
                    textField: { fullWidth: true },
                    actionBar: { actions: ["clear"] },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="EndDate"
                  value={endDate ? dayjs(endDate) : null}
                  onChange={(date: dayjs.Dayjs | null) =>
                    setEndDate(date ? date.format("YYYY-MM-DD") : null)
                  }
                  slotProps={{
                    textField: { fullWidth: true },
                    actionBar: { actions: ["clear"] },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid
              item
              xs={4}
              style={{
                margin: "0 auto",
              }}
            >
              {showButton && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      {action && (
        <div className="dummy-conatiner">
          <CircularProgress size={40} />
        </div>
      )}
      {data?.length > 0 && (
        <div
          className="ag-theme-alpine hideTransactionDetail"
          style={{ width: "100%", height: "425px", overflowY: "auto" }}
        >
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={50}
            pagination={true}
            rowData={data}
            columnDefs={columnDefs}
            enableCellTextSelection={true}
            onRowClicked={onRowClicked}
          ></AgGridReact>
        </div>
      )}
      {selectedRowData != null && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="dialogBox"
        >
          <h2
            style={{
              fontWeight: "bold",
              margin: "10px 0",
              paddingLeft: "10px",
            }}
          >
            Details
          </h2>
          <Grid
            container
            spacing={2}
            style={{
              margin: "3px 0 20px 0",
              width: "100%",
              padding: "0px 10px 0px 10px",
            }}
          >
            <Grid item xs={12} style={{ padding: "0" }}>
              <Grid container>
                <Grid item xs={5}>
                  <p className="tableHeader">Checkout Date</p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p className="tableData">
                    {selectedRowData.orderCheckoutDate}
                  </p>
                </Grid>

                <Grid item xs={5}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    Sub Category Name
                  </p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.subCategoryName}
                  </p>
                </Grid>

                <Grid item xs={5}>
                  <p className="tableHeader">Product Name</p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p className="tableData">{selectedRowData.productName}</p>
                </Grid>

                <Grid item xs={5}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    operator Name
                  </p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.operatorName}
                  </p>
                </Grid>

                <Grid item xs={5}>
                  <p className="tableHeader">Transaction ID </p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p className="tableData">{selectedRowData.transactionID}</p>
                </Grid>
                <Grid item xs={5}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    Email
                  </p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.userEmail}
                  </p>
                </Grid>
                <Grid item xs={5}>
                  <p className="tableHeader">Final Status</p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p className="tableData">
                    {selectedRowData.vendorFinalStatus}
                  </p>
                </Grid>
                <Grid item xs={5}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    Payment Method
                  </p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.paymentMethod}
                  </p>
                </Grid>
                <Grid item xs={5}>
                  <p className="tableHeader">Refund</p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p className="tableData">{selectedRowData.refund}</p>
                </Grid>
                <Grid item xs={5}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    Order Amount
                  </p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.orderAmount}
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Dialog>
      )}
    </motion.div>
  );
};

export default TransactionStatus;
